const calculateDeptPercentage = (dept) => {
  const cMIN = -50;
  const cMAX = 100;
  return (dept - cMIN) / (cMAX - cMIN);
};

const getFormattedPlayerData = (state) => {
  const { playerStates } = state.chugWars;
  const formattedPlayerStates = playerStates.map((player) => {
    const percentage = calculateDeptPercentage(player.dept);
    return {
      ...player,
      percentage,
    };
  });
  return formattedPlayerStates;
};

export { getFormattedPlayerData };
